import React from 'react';
import Box from '@mui/material/Box';
import {
  DataGrid,
  GridColDef,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from '@mui/x-data-grid';

const SampleListingsTable = ({ data, marketName }) => {
  const listingColumns = [
    { field: 'Airbnb Property ID', headerName: 'Airbnb Property ID', width: 150 },
    {
      field: 'Listing URL',
      headerName: 'Listing URL',
      width: 300,
      renderCell: params => (
        <a href={params.value} target="_blank" rel="noopener noreferrer">
          {params.value}
        </a>
      ),
    },
    { field: 'Listing Title', headerName: 'Title', width: 300 },
    { field: 'Property Type', headerName: 'Property Type', width: 200 },
    { field: 'Listing Type', headerName: 'Listing Type', width: 150 },
    { field: 'Created Date', headerName: 'Created Date', width: 150 },
    { field: 'Last Scraped Date', headerName: 'Last Scraped', width: 150 },
    { field: 'Country', headerName: 'Country', width: 100 },
    { field: 'City', headerName: 'City', width: 150 },
    { field: 'Number of Reviews', headerName: 'Reviews', width: 130 },
    { field: 'Bedrooms', headerName: 'Bedrooms', width: 100 },
    { field: 'Beds', headerName: 'Beds', width: 100 },
    { field: 'Bathrooms', headerName: 'Bathrooms', width: 120 },
    { field: 'Max Guests', headerName: 'Max Guests', width: 120 },
    { field: 'Airbnb Superhost', headerName: 'Superhost', width: 130 },
    { field: 'Cancellation Policy', headerName: 'Cancellation Policy', width: 200 },
    { field: 'Cleaning Fee', headerName: 'Cleaning Fee (USD)', width: 120 },
    { field: 'Extra People Fee', headerName: 'Extra People Fee (USD)', width: 150 },
    { field: 'Check-in Time', headerName: 'Check-in Time', width: 150 },
    { field: 'Check-out Time', headerName: 'Check-out Time', width: 150 },
    { field: 'Minimum Stay', headerName: 'Minimum Stay', width: 130 },
    { field: 'Latitude', headerName: 'Latitude', width: 150 },
    { field: 'Longitude', headerName: 'Longitude', width: 150 },
    { field: 'Exact Location', headerName: 'Exact Location', width: 150 },
    { field: 'Overall Rating', headerName: 'Overall Rating', width: 150 },
    { field: 'Airbnb Cleanliness Rating', headerName: 'Cleanliness Rating', width: 180 },
    { field: 'Airbnb Communication Rating', headerName: 'Communication Rating', width: 180 },
    { field: 'Airbnb Accuracy Rating', headerName: 'Accuracy Rating', width: 160 },
    { field: 'Airbnb Check-in Rating', headerName: 'Check-in Rating', width: 160 },
    { field: 'Airbnb Location Rating', headerName: 'Location Rating', width: 160 },
    { field: 'Airbnb Value Rating', headerName: 'Value Rating', width: 150 },
    { field: 'Amenities', headerName: 'Amenities', width: 300 },
    { field: 'License', headerName: 'License', width: 150 },
    { field: 'Airbnb Host ID', headerName: 'Host ID', width: 150 },
    { field: 'Host Name', headerName: 'Host Name', width: 150 },
    { field: 'Host Listing Count', headerName: 'Host Listings Count', width: 180 },
    { field: 'Host Language', headerName: 'Host Language', width: 200 },
    { field: 'Instantbook Enabled', headerName: 'Instantbook Enabled', width: 180 },
    { field: 'Listing Photo URL', headerName: 'Photo URL', width: 250 },
    { field: 'Image URLs', headerName: 'Additional Photos', width: 250 },
    { field: 'Pets Allowed', headerName: 'Pets Allowed', width: 150 },
  ];

  const listingRows = data.map((listing, index) => ({
    id: index,
    ...listing,
  }));

  const CustomToolbar = ({ fileName }) => {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport csvOptions={{ fileName: fileName, utf8WithBom: true }} />
      </GridToolbarContainer>
    );
  };

  return (
    <Box sx={{ height: 400, width: '100%' }}>
      <DataGrid
        rows={listingRows}
        columns={listingColumns}
        disableSelectionOnClick
        components={{
          Toolbar: props => (
            <CustomToolbar
              {...props}
              fileName={`Sample: ${marketName} Listings data - Airbtics.csv`}
            />
          ),
        }}
      />
    </Box>
  );
};

export default SampleListingsTable;
